export default __webpack_public_path__ + "static/media/Hammy.63a063b8.png";